/**
 * 낭만월운 API 응답 텍스트 정규화
 *
 * - 문장 구분자 `|` → 줄바꿈(`\n`)
 * - `**텍스트**` → `<strong>텍스트</strong>` (낭만궁합 formatContent 와 동일 규칙)
 *
 * 마스킹된 사주 이름은 `*ㅎ` 처럼 별표를 포함하므로, 캡처 내부에 `*` 가 들어가는
 * 경우는 매칭에서 제외해서 마스킹 토큰이 하이라이트되지 않도록 한다.
 * (`[^*]+?` 로 캡처)
 */
const formatString = (text) =>
  text
    .replace(/(?<!\*)\*\*([^*]+?)\*\*(?!\*)/g, '<strong>$1</strong>')
    .replaceAll('|', '\n');

export const transformMonthlyFortuneData = (input) => {
  if (input == null) return input;
  if (Array.isArray(input)) return input.map(transformMonthlyFortuneData);
  if (typeof input === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(input)) {
      out[k] = transformMonthlyFortuneData(v);
    }
    return out;
  }
  if (typeof input === 'string') return formatString(input);
  return input;
};
